import { Interaction } from '@rogers/analytics';
import { AnalyticsConfiguration } from './analytics-configuration';

export const modalPopup = 'modal popup';

export const selfServeCompleteEvent = {
  selfServeComplete: true,
};

export const pageViewEvent = {
  pageView: true,
};

export const pageViewAndError = {
  pageView: true,
  error: true,
};

export const pageViewAndInteractionEvents = {
  pageView: true,
  interaction: true,
};

export const selfServeStartEvent = {
  selfServeStart: true,
};

export const selfServeStartWithPageViewEvents = {
  pageView: true,
  selfServeStart: true,
};

export const selfServeStartWithPageViewAndMiscEvents = {
  pageView: true,
  selfServeStart: true,
  miscellaneous: true,
};

export const selfServeStartWithInteractionEvents = {
  interaction: true,
  selfServeStart: true,
};

export const selfServeCompleteWithPageViewEvents = {
  pageView: true,
  selfServeComplete: true,
};

export const selfServeCompleteWithPageViewAndMiscEvents = {
  pageView: true,
  selfServeComplete: true,
  miscellaneous: true,
};

export const selfServeCompleteWithInteractionEvents = {
  interaction: true,
  selfServeComplete: true,
};

export const selfServeStartWithPageViewAndInteractionEvents = {
  pageView: true,
  selfServeStart: true,
  interaction: true,
};

export const interactionEvent = {
  interaction: true,
};

export const selfServeSearchClickEvent = {
  search: true,
};

export const serviceAvailCheckEvent = {
  serviceAvailCheck: true,
};

export const interactionWithServiceAvailCheck = {
  interaction: true,
  serviceAvailCheck: true,
};

export const notificationEventWithMiscEvents = {
  notification: true,
  miscellaneous: true,
};

export const notificationEvent = {
  notification: true,
};

export const getAnalyticsConfiguration = ({
  pageName,
  pageHierarchy,
  selfServeName,
  selfServeType,
  events,
  interaction,
}: {
  pageName?: string;
  pageHierarchy?: string[];
  selfServeName?: string;
  selfServeType?: string;
  events?: { [_key: string]: boolean };
  interaction?: { name: string; type: string };
}) => {
  const selfServe = !!selfServeName
    ? {
        name: selfServeName,
        type: selfServeType,
      }
    : undefined;

  const page =
    pageName && pageHierarchy
      ? {
          name: pageName,
          hierarchy: [...pageHierarchy],
        }
      : undefined;
  return {
    page,
    selfServe,
    events,
    interaction,
  };
};

// This file can be used to common reusable analytics configuration consts
// Add any application level config here
export const GLOBAL_ANALYTICS_CONFIGURATION: AnalyticsConfiguration = {
  // Global analytics mapping object, each lazy loaded module should provide its own ANALYTICS_CONFIG,
  // module specific config can merge the global config
  mappings: {},
  callBackFunctions: {},
};

export const getInteractionObject = (name: string, type = 'click'): Interaction => ({
  name,
  type,
});
